// Batch actions from the retailer product list: above this selection size,
// a "select all" action goes through POST /retailers/{id}/products/batch
// (async pipeline shared with the merchandising view) instead of the
// synchronous /product/massupdate/ call.
import {fetch} from "utils/dataAccess";

export const BATCH_SELECTION_THRESHOLD = 100;

// dataAccess.fetch throws on non-2xx with hydra:description as the error
// message; the API sends this stable code when the same action type already
// runs on the retailer
export const BATCH_ALREADY_RUNNING = 'BATCH_ACTION_ALREADY_RUNNING';

// actions menu entry -> batchAction type, used to grey out the entries whose
// type is already running on the list's retailer
export const MENU_ACTION_TO_BATCH_TYPE = {
    active: 'activate',
    inactive: 'desactivate',
    removeRanking: 'removeRanking',
    addCategories: 'addCategory',
    deleteCategories: 'removeCategory',
    editGender: 'changeGender',
    editBrand: 'changeBrand',
    setCornerOnProducts: 'addCorner',
    deleteProducts: 'delete',
};

const iriToId = (value) => String(value).split('/').pop();

export const BATCH_ONLY_ACTIONS = ['rankingRemove'];

export function selectedProductIds(selected) {
    return selected.map((item) => iriToId(item['@id']));
}

// massupdate vocabulary (keyType/keyState) -> batch endpoint payload.
// Returns null for an action the batch pipeline does not support.
export function batchPayloadFromListAction(keyType, keyState) {
    switch (keyType) {
        case 'status':
            return {batchAction: keyState && '0' !== String(keyState) ? 'activate' : 'desactivate'};
        case 'gender':
            return {batchAction: 'changeGender', batchActionValue: iriToId(keyState)};
        case 'brand':
            return {batchAction: 'changeBrand', batchActionValue: iriToId(keyState)};
        case 'corner':
            return {batchAction: 'addCorner', batchActionValue: iriToId(keyState)};
        case 'categoryAdd':
            return {batchAction: 'addCategory', batchActionValue: keyState.map((category) => category.id)};
        case 'categoryDelete':
            return {batchAction: 'removeCategory', batchActionValue: keyState.map((category) => category.id)};
        case 'productDelete':
            return {batchAction: 'delete'};
        case 'rankingRemove':
            return {batchAction: 'removeRanking'};
        default:
            return null;
    }
}

export function launchProductListBatchAction(retailerId, body) {
    let headers = new Headers();
    headers.set('Accept', 'application/json');

    return fetch(`/retailers/${retailerId}/products/batch`, {
        method: "POST",
        body: JSON.stringify(body),
        headers,
    });
}

// The lock is per retailer: only the actions running on this retailer grey
// out the menu.
export function fetchRunningBatchActions(retailerId) {
    return fetch(`/batch_actions?pagination=false&status=running&retailer=${retailerId}`)
        .then((response) => response.json())
        .then((retrieved) => retrieved['hydra:member'] ?? []);
}
